import type { PlayerActionType } from "@mc/types"
import { apiRequest } from "./httpClient.js"

export function sendPlayerAction(serverId: string, action: PlayerActionType, player: string): Promise<void> {
  return apiRequest(`/api/v1/servers/${serverId}/players/action`, { method: "POST", body: { action, player } })
}
